// UI string translations (content like judgments comes bilingual from the API).
export const strings = {
  en: {
    nav_home: "Home",
    nav_updates: "Updates",
    nav_team: "Team",
    nav_advice: "Legal Help",
    nav_lawyers: "SC Lawyers",
    nav_about: "About",
    nav_junior_hub: "Resources",
    nav_resources_full: "Resources for Litigants and Lawyers",
    nav_insights: "Insights",
    get_help: "Get Help",
    admin: "Admin",
    know_more: "Know More",
    learn_more: "Learn about us",
    connect_title: "Connect with us",
    connect_sub: "Want to know more about Litigation India, volunteer as a lawyer, or partner with us? Leave your details and we'll reach out.",
    connect_send: "Send message",
    connect_success: "Thank you! We'll connect with you shortly.",
    browse_by_area: "Browse by area of law",
    browse_by_area_sub: "Jump to the judgments that matter to you.",
    pro_bono_badge: "Pro Bono",
    become_volunteer: "Are you a Supreme Court advocate? Volunteer an hour a week.",
    message_optional: "How can we help? (optional)",
    read_more: "Read in simple words",
    read: "Read",
    latest_updates: "Latest Supreme Court Judgments",
    latest_updates_sub: "Landmark Supreme Court of India rulings, explained in clear, plain language.",
    view_all_updates: "View all updates",
    our_mission: "Our Mission",
    our_goals: "Our Goals",
    meet_team: "Meet the Team",
    free_advice_title: "Free Legal Guidance",
    free_advice_sub: "Experienced Supreme Court advocates volunteer their time to help litigants and junior advocates understand their legal options — at no cost to you.",
    book_slot: "Request a free slot",
    explore_lawyers: "Talk to a lawyer",
    search_placeholder: "Search judgments, topics...",
    filter_area: "Area of Law",
    all_areas: "All Areas",
    no_results: "No judgments found.",
    background: "Background",
    the_decision: "The Decision",
    why_it_matters: "Why it matters for you",
    in_short: "In short",
    slides: "Story Slides",
    metadata: "Case Details",
    citation: "Citation",
    date: "Date",
    bench: "Bench",
    area_of_law: "Area of Law",
    verified: "Verified",
    ai_summary_note: "AI-assisted summary, reviewed and verified by our editorial team.",
    photos: "Photos",
    slide: "Slide",
    of: "of",
    contact: "Contact",
    experience: "Experience",
    years: "years",
    languages: "Languages",
    helps: "Guides",
    available_slots: "free slots open",
    no_slots: "No free slots right now. Please request a callback.",
    select_slot: "Choose a free slot",
    your_name: "Your name",
    your_phone: "Phone number",
    your_email: "Email (optional)",
    your_issue: "Briefly describe your issue",
    submit_request: "Submit request",
    booking_success: "Request sent! The lawyer's team will contact you.",
    // Help widget
    help_title: "Connect for Help",
    help_sub: "Need guidance? Call us, leave a message, or request a callback.",
    call_now: "Call now",
    request_callback: "Request a callback",
    leave_message: "Leave a message",
    message_label: "Your message",
    callback_success: "Thank you! We will reach out to you soon.",
    send: "Send",
    // footer
    footer_tagline: "Insight First, Action Next. A public-service initiative to make justice understandable for every Indian.",
    quick_links: "Quick Links",
    disclaimer: "Legal Disclaimer: The information and case summaries on this website are provided for general public understanding only and do not constitute legal advice. Accessing this website or any guidance here does not create an attorney-client relationship, which is established only upon a formal engagement with a lawyer. Litigation India is an informational, public-service platform — always consult a qualified advocate before acting on any information relating to your specific matter.",
    rights: "All rights reserved.",
    published_on: "Published",
    views: "views",
  },
  hi: {
    nav_home: "होम",
    nav_updates: "अपडेट्स",
    nav_team: "हमारी टीम",
    nav_advice: "कानूनी सहायता",
    nav_lawyers: "सुप्रीम कोर्ट वकील",
    nav_about: "हमारे बारे में",
    nav_junior_hub: "संसाधन",
    nav_resources_full: "वादकारियों और अधिवक्ताओं के लिए संसाधन",
    nav_insights: "इनसाइट्स",
    get_help: "मदद लें",
    learn_more: "हमारे बारे में जानें",
    admin: "एडमिन",
    read_more: "सरल भाषा में पढ़ें",
    read: "पढ़ें",
    latest_updates: "नवीनतम सुप्रीम कोर्ट फैसले",
    latest_updates_sub: "भारत के सर्वोच्च न्यायालय के महत्वपूर्ण फैसले, स्पष्ट और सरल भाषा में समझाए गए।",
    view_all_updates: "सभी अपडेट देखें",
    our_mission: "हमारा मिशन",
    our_goals: "हमारे लक्ष्य",
    meet_team: "हमारी टीम से मिलें",
    free_advice_title: "निःशुल्क कानूनी मार्गदर्शन",
    free_advice_sub: "अनुभवी सुप्रीम कोर्ट अधिवक्ता वादकारियों और जूनियर वकीलों के मार्गदर्शन के लिए अपना समय निःशुल्क देते हैं।",
    book_slot: "निःशुल्क स्लॉट का अनुरोध करें",
    explore_lawyers: "वकील से बात करें",
    search_placeholder: "फैसले, विषय खोजें...",
    filter_area: "कानून का क्षेत्र",
    all_areas: "सभी क्षेत्र",
    no_results: "कोई फैसला नहीं मिला।",
    background: "पृष्ठभूमि",
    the_decision: "फैसला",
    why_it_matters: "आपके लिए क्यों जरूरी",
    in_short: "संक्षेप में",
    slides: "कहानी स्लाइड्स",
    metadata: "मामले का विवरण",
    citation: "उद्धरण",
    date: "तारीख",
    bench: "पीठ",
    area_of_law: "कानून का क्षेत्र",
    verified: "सत्यापित",
    ai_summary_note: "AI की मदद से बना सारांश, हमारी संपादकीय टीम द्वारा समीक्षित एवं सत्यापित।",
    photos: "तस्वीरें",
    slide: "स्लाइड",
    of: "में से",
    contact: "संपर्क",
    experience: "अनुभव",
    years: "वर्ष",
    languages: "भाषाएं",
    helps: "मार्गदर्शन",
    available_slots: "निःशुल्क स्लॉट उपलब्ध",
    no_slots: "अभी कोई निःशुल्क स्लॉट नहीं है। कृपया कॉलबैक का अनुरोध करें।",
    select_slot: "एक निःशुल्क स्लॉट चुनें",
    your_name: "आपका नाम",
    your_phone: "फ़ोन नंबर",
    your_email: "ईमेल (वैकल्पिक)",
    your_issue: "अपनी समस्या संक्षेप में बताएं",
    submit_request: "अनुरोध भेजें",
    booking_success: "अनुरोध भेज दिया गया! वकील की टीम आपसे संपर्क करेगी।",
    help_title: "मदद के लिए जुड़ें",
    help_sub: "मार्गदर्शन चाहिए? हमें कॉल करें, संदेश छोड़ें, या कॉलबैक का अनुरोध करें।",
    call_now: "अभी कॉल करें",
    request_callback: "कॉलबैक का अनुरोध करें",
    leave_message: "संदेश छोड़ें",
    message_label: "आपका संदेश",
    callback_success: "धन्यवाद! हम जल्द ही आपसे संपर्क करेंगे।",
    send: "भेजें",
    footer_tagline: "हर भारतीय के लिए न्याय को समझने योग्य बनाने की एक जन-सेवा पहल।",
    quick_links: "त्वरित लिंक",
    disclaimer: "कानूनी अस्वीकरण: इस वेबसाइट पर दी गई जानकारी और केस सारांश केवल आम जनता की समझ के लिए हैं और कानूनी सलाह नहीं हैं। इस वेबसाइट तक पहुंच या यहां दिया गया कोई भी मार्गदर्शन वकील-मुवक्किल संबंध स्थापित नहीं करता, जो केवल किसी वकील के साथ औपचारिक अनुबंध पर ही स्थापित होता है। Litigation India एक सूचनात्मक, जन-सेवा मंच है — अपने विशिष्ट मामले में किसी भी जानकारी पर कार्रवाई करने से पहले हमेशा एक योग्य अधिवक्ता से सलाह लें।",
    rights: "सर्वाधिकार सुरक्षित।",
    published_on: "प्रकाशित",
    views: "बार देखा गया",
  },
};
